import { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { api, ApiError } from '../api/client.js';
import { useAuth } from '../auth/store.js';

export function AcceptInvitePage() {
  const { t } = useTranslation();
  const { token } = useParams<{ token: string }>();
  const nav = useNavigate();
  const setSession = useAuth((s) => s.setSession);
  const [displayName, setDisplayName] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    if (!token) return;
    setError(null);
    setBusy(true);
    try {
      const res = await api.acceptInvite(token, { displayName, password });
      setSession(res.user, res.accessToken, res.refreshToken);
      nav('/');
    } catch (err) {
      if (err instanceof ApiError && (err.status === 404 || err.status === 410)) {
        setError(t('acceptInvite.invalidOrExpired'));
      } else {
        setError(t('auth.networkError'));
      }
    } finally {
      setBusy(false);
    }
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
      <form onSubmit={submit} style={{ width: 360 }} className="card">
        <h2>{t('acceptInvite.title')}</h2>
        <p className="muted" style={{ fontSize: 13 }}>{t('acceptInvite.hint')}</p>
        {error && <div className="error-banner">{error}</div>}
        <div style={{ marginBottom: 12 }}>
          <label>{t('auth.displayName')}</label>
          <input value={displayName} onChange={(e) => setDisplayName(e.target.value)} required />
        </div>
        <div style={{ marginBottom: 16 }}>
          <label>{t('auth.password')}</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            minLength={8}
          />
        </div>
        <button type="submit" disabled={busy} style={{ width: '100%' }}>
          {t('acceptInvite.save')}
        </button>
      </form>
    </div>
  );
}
